import AsyncValidator from 'async-validator'
import { resetObject ,validatorZero} from '@/utils'
import ProductionTable from '@/components/productionTable/index';
import i18n from '@/lang'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'

/* const language = process.env.LANG */
const language = 'en'

export default {
  name:'intelligetWirelessSolution',
  components: {ProductionTable},
  data(){
    return{
      tab: 'bridge', // 网桥 bridge | router
      lang:language,
      radio:1,
      color:'',
      language:'',
      version: 'overseas', // 国外
      bridge:{
        selected:{
          transportMode:'1', // 传输模式
          transportLabel:this.$t('intelligentWirelessSolution.pointToPoint'),
          transportDistance:'100',//传输距离
          transportDistanceLabel:'100m',
          frequency:'1', //工作频段
          frequencyLabel:'2.4G',
        },
        IPCBitRate:'1', // IPC码流
        IPCBitRateLabel:'1Mbps', // 默认值
        numberofIPCs:'', // IPC数量
      },
      router:{
        selected: {
          usageScenarios:'1', //使用场景 室内 | 室外
          usageScenariosLabel:this.$t('switchAccessCalculator.environment.indoor'),
          frequency:'1', //工作频段
          frequencyLabel:'2.4G',
        },
        room:'', // 房间数
        restaurantL:'', //餐厅长度
        restaurantW:'', //餐厅宽度
        squareL:'', //广场长
        squareW:'',// 广场宽
      },
      defaultInfos:{
        bridge:{
          selected:{
            transportMode:'1', // 传输模式
            transportLabel:this.$t('intelligentWirelessSolution.pointToPoint'),
            transportDistance:'100',//传输距离
            transportDistanceLabel:'100m',
            frequency:'1', //工作频段
            frequencyLabel:'2.4G',
          },
          numberofIPCs:'', // IPC数量
          IPCBitRate:'1', // IPC码流
          IPCBitRateLabel:'1Mbps', // 默认值
        },
        router:{
          selected: {
            usageScenarios:'1', //使用场景 室内 | 室外
            usageScenariosLabel:this.$t('switchAccessCalculator.environment.indoor'),
            frequency:'1', //工作频段
            frequencyLabel:'2.4G',
          },
          room:'', // 房间数
          restaurantL:'', //餐厅长度
          restaurantW:'', //餐厅宽度
          squareL:'', //广场长
          squareW:'',// 广场宽
        },
      },
      // 表格信息
      tableInfo:[],
      result: {
        bridge: {
          show: false //是否显示结果
        },
        router: {
          show: false //是否显示结果
        }
      },
      picker: {
        transportMode:[
          {label:'intelligentWirelessSolution.pointToPoint',value:'1'},
          {label:'intelligentWirelessSolution.pointToMultipoint',value:'2'},
        ],
        frequency:[
          {label:'2.4G',value:1},
          {label:'5.8G',value:2},
        ],
        transportDistance:[
          {label:'100m',value:'100'},
          {label:'400m',value:'400'},
          {label:'1500m',value:'1500'},
          {label:'3000m',value:'3000'},
          {label:'5000m',value:'5000'},
        ],
        IPCBitRate:[{label:'1Mbps',value:'1'},
          {label:'2Mbps',value:'2'},
          {label:'3Mbps',value:'3'},
          {label:'4Mbps',value:'4'},
          {label:'5Mbps',value:'5'},
          {label:'6Mbps',value:'6'},
          {label:'7Mbps',value:'7'},
          {label:'8Mbps',value:'8'},
          {label:'16Mbps',value:'16'},
          {label:'32Mbps',value:'32'}],
        usageScenarios:[
          {label:'intelligentWirelessSolution.room',value:'1'},
          {label:'intelligentWirelessSolution.hall',value:'3'},
          {label:'intelligentWirelessSolution.square',value:'4'},
        ],
        routerFrequency:[
          {label:'2.4G',value:'1'},
          {label:'2.4G & 5.8G',value:'2'},
        ]
      },
      rules: {
        /* bridge: {
          numberofIPCs: [
            {required: true, message: this.$t('intelligentWirelessSolution.inputNumOfIPC')},
          ]
        }, */
      },
    }
  },
  computed:{
    isActive:function () {
      // if (this.tab==='router')
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.color = val.query.color
        this.language = val.query.language
        if (this.color) {
          this.color = '#' + this.color
          document.getElementsByTagName('body')[0].style.setProperty('--test',this.color)
        }
        if (this.language) {
          this.lang = this.language
          i18n.locale = this.language
          import(`@/styles/${this.language}/index.scss`)
          document.documentElement.lang = this.language
        } /* else {
          i18n.locale = 'en'
          import(`@/styles/en/index.scss`)
          document.documentElement.lang = 'en'
        } */

        if (this.language === 'zh'){
          Vue.use(ElementUI)
        }else if(this.language !== 'zh'){
          Vue.use(ElementUI, {locale})
        }
      },
      immediate: true,
      deep: true
    },
    // 侦听表单变化
    'bridge.selected': {
      handler: function (newVal, oldVal) {
        this.result.bridge.show = false
      },
      deep: true
    },
    tab: {
      handler: function (newVal, oldVal) {
        this['result'][this.tab].show = false
      },
    },
    radio: {
      handler: function (newVal, oldVal) {
        if (newVal === 1) {
          this.picker.transportDistance = [
            {label:'100m',value:'100'},
            {label:'400m',value:'400'},
            {label:'1500m',value:'1500'},
            {label:'3000m',value:'3000'},
            {label:'5000m',value:'5000'},
          ]
          this['result'][this.tab].show = false
        } else {
          this.picker.transportDistance = [
            {label:'330ft',value:'100'},
            {label:'1300ft',value:'400'},
            {label:'5000ft',value:'1500'},
            {label:'10000ft',value:'3000'},
            {label:'16400ft',value:'5000'},
          ]
          this['result'][this.tab].show = false
        }
      }
    }
  },
  beforeCreate: function () {
    document.title = this.$t('intelligentWirelessSolution.common')
  },
  methods: {
    reset: function() {
      resetObject(this[this.tab], this['defaultInfos'][this.tab])
      if (this.tab === 'bridge'){
        this[this.tab].selected.transportMode = this.defaultInfos[this.tab].selected.transportMode
        this[this.tab].selected.transportLabel = this.defaultInfos[this.tab].selected.transportLabel
        this[this.tab].selected.transportDistance = this.defaultInfos[this.tab].selected.transportDistance
        this[this.tab].selected.transportDistanceLabel = this.defaultInfos[this.tab].selected.transportDistanceLabel
        this[this.tab].selected.frequency = this.defaultInfos[this.tab].selected.frequency
        this[this.tab].selected.frequencyLabel = this.defaultInfos[this.tab].selected.frequencyLabel
      }else if (this.tab  === 'router'){
        this[this.tab].selected.usageScenarios = this.defaultInfos[this.tab].selected.usageScenarios
        this[this.tab].selected.usageScenariosLabel = this.defaultInfos[this.tab].selected.usageScenariosLabel
        this[this.tab].selected.frequency = this.defaultInfos[this.tab].selected.frequency
        this[this.tab].selected.frequencyLabel = this.defaultInfos[this.tab].selected.frequencyLabel
      }
      this['result'][this.tab].show = false
    },
    validateDatas: function() {
      let self = this,
        data = self[self.tab],
        rules = {}
      if (self['tab']==='router' && self.router.selected.usageScenarios === '1'){
        rules.room = [{required: true, message: this.$t('intelligentWirelessSolution.inputNumOfRooms')}]
      }else if (self['tab']==='router' && self.router.selected.usageScenarios === '3'){
        rules.restaurantL = [
          {required: true, message: this.$t('intelligentWirelessSolution.inputLengthOfRooms')},
          validatorZero(this.$t('intelligentWirelessSolution.roomLength'))
        ]
        rules.restaurantW = [
          {required: true, message: this.$t('intelligentWirelessSolution.inputWidthOfRooms')},
          validatorZero(this.$t('intelligentWirelessSolution.roomWidth'))
        ]
      }else if (self['tab']==='router' && self.router.selected.usageScenarios === '4'){
        rules.squareL = [
          {required: true, message: this.$t('intelligentWirelessSolution.inputLengthOfSquare')},
          validatorZero(this.$t('intelligentWirelessSolution.squareLength'))
        ]
        rules.squareW = [
          {required: true, message: this.$t('intelligentWirelessSolution.inputWidthOfSquare')},
          validatorZero(this.$t('intelligentWirelessSolution.squareWidth'))
        ]
      }else if (self['tab']==='bridge'){
        rules.numberofIPCs = [
          {required: true, message: this.$t('intelligentWirelessSolution.inputNumOfIPC')},
          validatorZero(this.$t('intelligentWirelessSolution.IPCnum'))
        ]
      }
      Object.assign(rules,self.rules[self.tab])
      
      if(rules) {
        var validator = new AsyncValidator(rules)
        validator.validate(data, { firstFields: true }, (errors, fields) => {
          if(errors) {
            self.$message(errors[0].message)
          }
          else {
            self.compute()
          }
        })
      }
      /* else {
        self.compute()
      } */
    },
    compute: function() {
      if(this.tab === 'bridge'){

        let sendData = {
          ipcNum:this.bridge.numberofIPCs, // ipc数量
          stream:Number(this.bridge.IPCBitRate), // 码率
          transmissionDistance:this.bridge.selected.transportDistance, // 传输距离
          transmissionTypeValue:this.bridge.selected.transportMode, // 传输模式
          workingFrequencyBandValue:this.bridge.selected.frequency, // 传输频段
          version:this.version
        }

        this.$http.get("https://toolbox.dahuatech.com:8443/securityCalculate/intelligentWireless/recommendNetworkBridge",{params:sendData}).then((res)=>{
          let data = res.data.data
          this.tableInfo = data.deviceCandidates
          this.result.bridge.show = true
          /* if (sendData.transmissionTypeValue == 1){
            this.tableInfo = data.deviceCandidates
            this.result.bridge.show = true
          }else {
            this.tableInfo = data.deviceCandidates
            this.result.bridge.show = true
          } */
        })
      }else if (this.tab === 'router'){
        let sendData = {
          workingPlaceValue:this.router.selected.usageScenarios, // 使用场景
          workingFrequencyBandValue:this.router.selected.frequency,//工作频段
          version:this.version
        }

        if (this.router.selected.usageScenarios == '1'){
          sendData.roomNum = this.router.room
        }else if(this.router.selected.usageScenarios == '3' && this.radio === 1){
          sendData.length = this.router.restaurantL
          sendData.weight = this.router.restaurantW
        }else if(this.router.selected.usageScenarios == '3' && this.radio === 2){
          sendData.length = this.router.restaurantL * 0.3048
          sendData.weight = this.router.restaurantW * 0.3048
        }else if(this.router.selected.usageScenarios == '4' && this.radio === 1){
          sendData.length = this.router.squareL
          sendData.weight = this.router.squareW
        } else if(this.router.selected.usageScenarios == '4' && this.radio === 2){
          sendData.length = this.router.squareL * 0.3048
          sendData.weight = this.router.squareW * 0.3048
        }
        this.$http.get("https://toolbox.dahuatech.com:8443/securityCalculate/intelligentWireless/recommendRouter",{params:sendData}).then((res)=>{
          let data = res.data.data
          this.tableInfo = data.deviceCandidates
          this.result.router.show = true
        })
      }
    },

    /**
     * 字段校验
     * @param string fieldName 字段名称
     * @param string type 校验类型 positive|positiveInt 正数允许两位小数|正整数
     * @return void
     */
    validateField: function (fieldName, type) {
      // 修改范围1-100
      let value = ''
      if(type === 'positive') {
        value = this[this.tab][fieldName]
        .replace(/[^0-9.]/g,'')
        .replace(/\.{2,}/g,'.')
        .replace(/^\./,'')
        .replace('.','$#$')
        .replace(/\./g,'')
        .replace('$#$','.')
        .replace(/^(\d+)\.(\d{2}).*$/,'$1.$2')
        .replace(/^99999999\.\d*$/,'99999999')

        if (parseInt(value) > 99999999){
          value = '99999999'
        }

      }
      else if(type === 'positiveInt') {
        // 修改范围1-9999999
        // 去除非0-9的数字
        value = this[this.tab][fieldName].replace(/[^0-9]/g, '')
        // 去除开头不是0的数字
        value = value.replace(/^0*(\d*)$/g, '$1')

        if (parseInt(value) > 99999999){
          value = '99999999'
        }

      }
      this[this.tab][fieldName] = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/intelligentWirelessSolution/index.js